/**
 * Determines whether the live thinking indicator should be hidden for an assistant message.
 *
 * Returns true when:
 * - Virtualization is active and the message is not actively
 *   generating (prevents a flash of the indicator when reopening a completed conversation), OR
 * - The message's streaming is already complete (prevents the indicator from briefly re-appearing
 *   between when traces are cleared on FINAL_RESPONSE and when the store status transitions to idle), OR
 * - The message has already received an answer part (traces are done, answer is streaming in —
 *   prevents the thinking indicator from reappearing during the answer streaming phase).
 */
export const shouldHideLiveThinkingIndicator = ({
	isVirtualizationEnabled,
	isAssistantActivelyGenerating,
	streamingComplete,
	hasReceivedAnswerPart,
}: {
	isVirtualizationEnabled: boolean;
	isAssistantActivelyGenerating: boolean;
	streamingComplete: boolean | undefined;
	hasReceivedAnswerPart: boolean | undefined;
}): boolean =>
	(isVirtualizationEnabled ? !isAssistantActivelyGenerating : false) ||
	streamingComplete === true ||
	hasReceivedAnswerPart === true;
